module.exports = __webpack_public_path__ + "img/aston-university-online-thumb.af3d2580.webp";